export const headerData = [
  {
    text: "Promo ID",
  },
  {
    text: "SKU",
  },
  {
    text: "Status",
  },
];

export const footerData = {
  title: "No promo yet",
  subTtitle: "Try the blue button on the top right and add a few!",
  imgSrc: "../../../assets/images/no-search-icon.svg",
  alt: "no search found",
};

export const bodyDataAndKeyTypes = [
  {
    key: "promoCode",
    type: "",
  },
  {
    key: "productTitle",
    type: "",
  },
  {
    key: "promoStatus",
    type: "",
  },
];

export const promoProductHeaderData = [
  {
    text: "",
  },
  {
    text: "Items",
  },
  {
    text: "Price",
  },
];

export const promoProductBodyDataAndKeyTypes = [
  {
    key: "itemName",
    type: "",
    prepend: "",
  },
  {
    key: "itemAvailable",
    type: "",
    prepend: "",
  },
];

export const promoBasketProductBodyDataAndKeyTypes = [
  {
    key: "isChecked",
    type: "checkbox",
    prepend: "",
  },
  {
    key: "itemName",
    type: "",
    prepend: "",
  },
];

export const promoProductFooterData = {
  title: "No record found",
  subTtitle: "No such order exists. Create one?",
  imgSrc: "../../../assets/images/no-search-icon.svg",
  alt: "no search found",
};

export const FLAT_DISCOUNT_ALREADY_APPLIED = "Already assigned a flat discount";
export const VOLUMETRIC_DISCOUNT_ALREADY_APPLIED =
  "Already assigned a volumetric discount";
export const DYNAMIC_DISCOUNT_ALREADY_APPLIED =
  "Already assigned a dynamic discount";
export const USER_LEVEL_DISCOUNT_ALREADY_APPLIED =
  "Already assigned a user level discount";
export const PROMO_ALREADY_APPLIED = "Promo already applied";
